import React, { useState } from 'react';
import './App.css';
import LinkSDK from './components/LinkSDK';
import Start from './containers/Start';
import Connected from './containers/Connected';
import defaultIcon from './images/defaultAppIcon.png'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const App = () => {
  const [ sdkActive, setSdkActive ] = useState(false);
  const [ sdkFlow, setSdkFlow ] = useState("LINK"); 
  const [ selectedBank, setSelectedBank ] = useState("Noor Bank")
  const [ connected, setConnected ] = useState(false)
  const [ paymentsActive, setPaymentsActive ] = useState(false)
  const [ applicationName, setApplicationName ] = useState("Finalley")
  const [ appIcon, setAppIcon ] = useState(defaultIcon)
  const [ sdkPaymentState, setSdkPaymentState ] = useState({})
  const [ payments, setPayments ] = useState([])
  const [ country, setCountry ] = useState("ARE")

  const activateSDK = () => {
    setSdkActive(true)
  }

  const setPaymentDone = () => {
    setPaymentsActive(true)
  }

  const configureSDKState = (state, value, account) => {
    
      if(state === "INITIATE_PAYMENT") {
        setSdkFlow("PAY")
      } else {
        setSdkFlow("LINK")
      }
      setSdkActive(true)
      setSdkPaymentState({value, account})
  }

  const updatePayments = (value, account) => {
    const tempArr = [...payments]
    const now = new Date()
    if(value && account) {
      const payment = {
        "payment_intent_id": "9dafc6f5-37e8-4f72-aa0b-5323c0935c5f",
        "customer_id": "6bc2336a-6d74-4e59-a492-65313423a8f8",
        "amount": value,
        "currency": account.currency_code,
        "payments": [
          {
            "id": uuidv4(),
            "payment_intent_id": "9dafc6f5-37e8-4f72-aa0b-5323c0935c5f",
            "sender_details": {
              "account_number": account.iban.slice(-12),
              "iban": account.iban
            },
            "recipient_details": {
                "account_number": "XXXXXXXXXXXX",
                "iban": "AE870200000XXXXXXXXXXXX",
                "name": "Al Fulani"
            },
            "amount": value,
            "currency": account.currency_code,
            "description": "77f0c07e7b7b4677bb056261f9eead0c",
            "submission_timestamp": now,
            "initiation_timestamp": now,
            "status": "ACCEPTED_BY_BANK",
            "bank_transaction_reference": "0492981211381081"
          }
        ],
        "payment_destination": {
          "id": "95c29647-c568-40d7-8710-3e330de1b5f2",
          "bank_identifier": "HSBC_UAE",
          "name": "Acme Corp.",
          "iban": "AE870200000XXXXXXXXXXXX",
          "display_name": "Acme Corp.",
          "account_number": "XXXXXXXXXXXX",
          "swift_code": "BBMEAEAD",
          "status": "CONFIRMED",
          "address": "Acme Towers, 51st Floor",
          "country": "ARE",
          "city": "Dubai",
          "default": true,
          "customer_id": null,
          "owner_type": "APPLICATION"
        }, 
        account
      }
      let obj = JSON.parse(JSON.stringify(payment));
      tempArr.push(obj)
      setPayments(tempArr)
    }
  }

  return (
    <Wrapper>
      {!connected &&
        <Start 
          applicationName={applicationName} 
          setApplicationName={setApplicationName} 
          activateSDK={activateSDK}
          appIcon={appIcon}
          setAppIcon={setAppIcon}
          country={country}
          setCountry={setCountry}
        />
      }
      {connected &&
        <Connected 
          selectedBank={selectedBank} 
          appIcon={appIcon} 
          applicationName={applicationName} 
          setConnected={setConnected}
          configureSDKState={configureSDKState}
          payments={payments}
          paymentsActive={paymentsActive}
          country={country}
        />
      }
      <LinkSDK 
        isActive={sdkActive}
        setIsActive={setSdkActive}
        selectedBank={selectedBank}
        setSelectedBank={setSelectedBank}
        applicationName={applicationName}
        appIcon={appIcon} 
        setConnected={setConnected}
        activateSDK={activateSDK}
        sdkFlow={sdkFlow}
        updatePayments={updatePayments}
        sdkPaymentState={sdkPaymentState}
        setPaymentDone={setPaymentDone}
        country={country}
      />
    </Wrapper>
  );
}

export default App;
